import React from 'react';
import { useCart } from '../context/CartContext';
import './Products.css';

function Sports() {
  const { addToCart } = useCart();

  const sportsProducts = [
    {
      id: 'sport1',
      name: 'Running Shoes Pro',
      price: 89,
      originalPrice: 129,
      image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Professional running shoes with cushioning'
    },
    {
      id: 'sport2',
      name: 'Yoga Mat Premium',
      price: 29,
      originalPrice: 45,
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Non-slip yoga mat for home workouts'
    },
    {
      id: 'sport3',
      name: 'Dumbbell Set',
      price: 79,
      originalPrice: 99,
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Adjustable dumbbell set 5-50 lbs'
    },
    {
      id: 'sport4',
      name: 'Basketball',
      price: 24,
      originalPrice: 35,
      image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Official size basketball for indoor/outdoor'
    },
    {
      id: 'sport5',
      name: 'Fitness Tracker',
      price: 59,
      originalPrice: 79,
      image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Smart fitness tracker with heart rate monitor'
    },
    {
      id: 'sport6',
      name: 'Tennis Racket',
      price: 89,
      originalPrice: 119,
      image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Professional tennis racket with case'
    },
    {
      id: 'sport7',
      name: 'Resistance Bands',
      price: 19,
      originalPrice: 29,
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Set of 5 resistance bands for strength training'
    },
    {
      id: 'sport8',
      name: 'Cycling Helmet',
      price: 49,
      originalPrice: 69,
      image: 'https://images.unsplash.com/photo-1507035895480-2b3156c31fc8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Sports',
      description: 'Lightweight cycling helmet with ventilation'
    }
  ];

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Sports</h1>
          <p>Fitness and outdoor gear for active lifestyle</p>
        </div>
        
        <div className="product-grid">
          {sportsProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p className="product-description">{product.description}</p>
                <div className="price">
                  <span className="current-price">${product.price}</span>
                  <span className="original-price">${product.originalPrice}</span>
                  <span className="discount">
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                  </span>
                </div>
                <button 
                  className="add-to-cart"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Sports; 